/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import { FileType } from "Api";
import { ValidationResult } from "./QuickFormValidationRules";

export enum TransformStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  SUCCESS = "success",
  FAILED = "failed",
}

export enum UploadStatus {
  PENDING = "pending",
  UPLOADING = "uploading",
  COMPLETE = "complete",
  CANCELLED = "cancelled",
  FAILED = "failed",
}

export interface QuickFormFile {
  id: string;
  fileInfo: {
    id: string;
    attributes?: {
      name?: string;
      sizeMbs?: number;
      uploadDateUtc?: string;
    };
  };
  detectedType: FileType | null;
  transformTo: FileType | null;
  uploadStatus: UploadStatus;
  uploadProgress: number;
  transformStatus: TransformStatus;
  selected: boolean;
  errorMessage?: string;
  sizeMbs?: number;
  validationResult?: ValidationResult;
}

export interface TransformStats {
  totalFiles: number;
  pending: number;
  processing: number;
  success: number;
  failed: number;
}
